(function () {
	const initProductAccordion = () => {
		const aboutToggleItems = $(".about__accordion-toggle");

		aboutToggleItems.each(function () {
			const currentToggle = $(this);
			const siblingToggles = currentToggle.siblings(
				".about__accordion-description"
			);

			currentToggle.click(function () {
				if (!currentToggle.hasClass("active")) {
					aboutToggleItems.each(function () {
						const siblingToggle = $(this);
						siblingToggle.removeClass("active");
						siblingToggle
							.siblings(".about__accordion-description")
							.stop()
							.slideUp(300);
					});

					currentToggle.addClass("active");

					siblingToggles.stop().slideDown(300);
				} else {
					currentToggle.removeClass("active");
					siblingToggles.stop().slideUp(300);
				}
			});
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper?.querySelectorAll(".js-image-zoom") || [];

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	const formatFreeShippingAmount = (value) => {
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		const formatString = theme.moneyFormat;

		return formatString.replace(placeholderRegex, value);
	};

	const setTotalFreeShipping = () => {
		if (document.querySelector(".js-free-shipping")) {
			const freeShippingTotal = document.querySelector(".free-shipping-total");
			if (freeShippingTotal) {
				const minSpend = Number(freeShippingTotal.dataset.minSpend);
				if (minSpend && minSpend > 0) {
					freeShippingTotal.innerText = `${formatFreeShippingAmount(
						Math.round(minSpend * (Shopify.currency.rate || 1))
					)}`;
				}
			}
		}
	};

	// NegoStore (perf 09.10.2026): bara plutitoare (floated_form). Inainte, fiecare eveniment
	// de scroll lega inca un listener de click pe buton (sute intr-o sesiune, iar un tap pornea
	// cate un scrollTo pentru fiecare) si citea layout-ul (getBoundingClientRect x2), inclusiv
	// la incarcare, cand forta recalcularea stilurilor. Acum click-ul e legat o singura data,
	// delegat pe document (merge si dupa reincarcarea sectiunii in editor), iar pozitiile nu se
	// mai citesc deloc: un IntersectionObserver urmareste cand sectiunea produsului iese pe sus
	// (deci sectiunea de dupa ea, recomandarile, a ajuns sus) si cand footer-ul intra pe ecran.
	// Observer-ul tine cont singur de resize si de inaltimea recomandarilor dupa fetch, asa ca
	// nu mai e nevoie de listener de scroll. Comportamentul ramane: bara apare cand
	// recomandarile ajung sus, dispare la footer, iar butonul urca la formular.
	let stickyBar = null;
	let floatedObserver = null;
	let passedProduct = false;
	let beforeFooter = false;

	const updateFloatedBar = () => {
		if (!stickyBar) return;
		const activeOffset = passedProduct && beforeFooter;

		if (stickyBar.classList.contains("active") !== activeOffset) {
			stickyBar.classList.toggle("active", activeOffset);
		}
	};

	const revealPopup = () => {
		if (floatedObserver) floatedObserver.disconnect();
		floatedObserver = null;
		passedProduct = false;
		beforeFooter = false;

		stickyBar = document.querySelector(".floated_form");
		const secondSection = document.querySelector(".product-section + section");
		const productSection = secondSection
			? secondSection.previousElementSibling
			: null;
		const footer = document.querySelector("footer");

		if (
			!stickyBar ||
			!productSection ||
			!footer ||
			!("IntersectionObserver" in window)
		) {
			return;
		}

		// Ca inainte: activa cand window.scrollY > inceputul sectiunii de dupa produs
		// (= marginea de jos a sectiunii produsului a trecut de sus) si cand
		// scrollY + innerHeight < inceputul footer-ului (footer-ul e inca sub ecran).
		floatedObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const rect = entry.boundingClientRect;
				if (entry.target === footer) {
					beforeFooter = !entry.isIntersecting && rect.top > 0;
				} else {
					passedProduct = !entry.isIntersecting && rect.bottom <= 0;
				}
			});
			updateFloatedBar();
		});
		floatedObserver.observe(productSection);
		floatedObserver.observe(footer);
	};

	document.addEventListener("click", (event) => {
		const target = event.target;
		if (target instanceof Element && target.closest(".floated_form-button")) {
			window.scrollTo({ top: 0, behavior: "smooth" });
		}
	});

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		setTotalFreeShipping();
		revealPopup();
	});

	initProductAccordion();
	setTotalFreeShipping();
	revealPopup();
})();
